import type { VoidFunctionComponent } from 'react';

import {
  type SavedResourceAction,
  type SavedResourceActionType,
  SavedResourceDropdownActions,
} from './SavedResourceDropdownActions';
import { type ResourceOption, SavedResourceDropdownList } from './SavedResourceDropdownList';
import type { ResourceType } from './types';

import styles from './SavedResource.module.less';

type Props = {
  resourceType: ResourceType;
  resources: ResourceOption[];
  currentResource: ResourceOption;
  isLoading: boolean;
  onChangeDropdownList: (resource: ResourceOption['id']) => void;
  onChangeDropdownActions: (action: SavedResourceActionType) => void;
  hasAnyEditPermission: boolean;
  hasNotificationDot: boolean;
  actions: SavedResourceAction[];
  isDisabled: boolean;
  /**
   * Whether to hide the id of the resource in the dropdown. Useful for resources that need to be identified by users
   * in the CLI by ID, such as saved issue filters.
   */
  shouldHideId?: boolean;
};

export const SavedResourceDropdownContainer: VoidFunctionComponent<Props> = ({
  resourceType,
  resources,
  currentResource,
  isLoading,
  onChangeDropdownList,
  onChangeDropdownActions,
  hasAnyEditPermission,
  hasNotificationDot,
  actions,
  isDisabled,
  shouldHideId,
}) => {
  return (
    <div className={styles.savedResourceDropdownContainer}>
      <SavedResourceDropdownList
        resourceType={resourceType}
        resources={resources}
        currentResource={currentResource}
        isLoading={isLoading}
        onChange={onChangeDropdownList}
        shouldHideId={shouldHideId}
      />
      <SavedResourceDropdownActions
        resourceType={resourceType}
        actions={actions}
        isDisabled={isDisabled}
        hasAnyEditPermission={hasAnyEditPermission}
        onChange={onChangeDropdownActions}
        hasNotificationDot={hasNotificationDot}
      />
    </div>
  );
};
